<h2>Verander van Rol</h2>
<div class="row">
  <div class="col-12">
    Selecteer hieronder welke rol u tijdelijk wil aannemen.< br/> Om terug
    administrator te worden moet u opnieuw aanmelden.<br />
    <button (click)="switchToChef()" class="btn btn-primary">Chef</button>&nbsp;
    <button (click)="switchToKeuken()" class="btn btn-primary">Keuken</button>
  </div>
</div>
